import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { Box, Button, CircularProgress } from '@mui/material';
import { HPOSchema } from '@/zod_schemas';

interface GetHPOColumnsProps {
  deleteAction?: boolean;
  onClickDelete?: (id: string, name: string) => void;
  deletingRowId?: string | null;
  isDeleting?: boolean;
}

export const getHPOColumns = ({
  deleteAction = false,
  onClickDelete,
  deletingRowId,
  isDeleting = false,
}: GetHPOColumnsProps): GridColDef<HPOSchema>[] => {
  const columns: GridColDef<HPOSchema>[] = [
    {
      field: 'hpo_id',
      headerName: 'Term Identifier',
      flex: 1,
    },
    {
      field: 'name',
      headerName: 'Term Name',
      flex: 1,
    },
    {
      field: 'synonyms',
      headerName: 'Matching String',
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ whiteSpace: 'pre-line' }}>
          {Array.isArray(params.value) ? params.value.join('\n') : ''}
        </Box>
      ),
    },
  ];

  if (deleteAction) {
    columns.push({
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      flex: 0.8,
      renderCell: (params: GridRenderCellParams<HPOSchema>) => {
        const rowId = String(params.row.id ?? params.row.id ?? '');
        const rowName = String(params.row.hpo_id ?? params.row.name ?? rowId);

        const isThisRowDeleting = deletingRowId === rowId;

        return (
          <Box>
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={() => {
                if (!rowId) return;
                onClickDelete?.(rowId, rowName);
              }}
              disabled={isDeleting || !rowId}
              startIcon={
                isThisRowDeleting ? (
                  <CircularProgress size={16} color="inherit" />
                ) : null
              }
              sx={{ ml: 1 }}
            >
              {isThisRowDeleting ? 'Deleting...' : 'Delete'}
            </Button>
          </Box>
        );
      },
    });
  }

  // if (selectAction) {
  //   columns.push({
  //     field: 'actions',
  //     headerName: 'Actions',
  //     sortable: false,
  //     flex: 0.8,
  //     renderCell: (params) => (
  //       <Box>
  //         <Button
  //           variant="contained"
  //           color="primary"
  //           size="small"
  //           onClick={() => {
  //             const rowData = params.row;

  //             if (
  //               formPatientId &&
  //               formMode === 'update' &&
  //               handleConfirmClick &&
  //               type
  //             ) {
  //               handleConfirmClick(rowData, type);
  //             } else {
  //               if (handleConfirmClick && type) {
  //                 handleConfirmClick(rowData, type);
  //             }

  //               if (setDialogOpen) {
  //                 setDialogOpen(false);
  //               }
  //             }
  //           }}
  //           style={{ marginLeft: 8 }}
  //         >
  //           Select
  //         </Button>
  //       </Box>
  //     ),
  //   });
  // }

  return columns;
};
